import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppSettingsComponent } from './app-settings/app-settings.component';
import { LoginComponent } from "./auth-pages/login.component";
import { LogoutComponent } from './auth-pages/logout.component';
import { NotFoundComponent } from "./auth-pages/not-found.component";
import { SigninOidcComponent } from './auth-pages/signin-oidc.component';
import { UnauthorizedComponent } from "./auth-pages/unauthorized.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { AntiForgeryResolver } from './core/resolvers/anti-forgery.resolver';
import { ImmTaskAmendmentEditComponent } from "./imm-task-amendment/imm-task-amendment-edit/imm-task-amendment-edit.component";
import { ImmTaskAmendmentComponent } from "./imm-task-amendment/imm-task-amendment.component";
import { AuthorisedLayoutComponent } from './layouts/authorised-layout/authorised-layout.component';
import { GuestLayoutComponent } from './layouts/guest-layout/guest-layout.component';
import { LandingPageComponent } from './layouts/landing-page/landing-page.component';
import { LookupTypeAmendmentComponent } from "./lookup-type- amendment/lookup-type-amendment/lookup-type-amendment.component";
import { PrivacyPolicyComponent } from "./auth-pages/privacy-policy.component";

import { TaskAmendmentComponent } from './task-amendment/task-amendment.component';
import { ImmTemplateGeneratorComponent } from './template-generator/imm-template-generator/imm-template-generator.component';
import { GovTemplateGeneratorComponent } from './Govtemplate-generator/gov-template-generator/gov-template-generator.component';
import { TemplateGeneratorComponent } from './template-generator/template-generator.component';
import { ExitTaskAmendmentComponent } from "./exit-task-amendment/exit-task-amendment.component";
import { ExitTaskAmendEditComponent } from "./exit-task-amendment/exit-task-amend-edit/exit-task-amend-edit.component";
import { ExitTemplateGeneratorComponent } from "./exit-template-generator/exit-template-generator.component";
import { EmployeeProfileUpdateGuard } from "./core/guards/employee-profile-update.guard";
import { ImmDocumentVisamappingComponent } from "./imm-document-visamapping/imm-document-visamapping.component";
import { GovernanceDocTypesComponent } from "./governance-doc-types/governance-doc-types.component";
import { GovernanceActivitiesComponent } from "./governance-activities/governance-activities.component";
import { MsalGuard } from "@azure/msal-angular";
import { GovernanceNewdocTypesComponent } from "./governance-newdoc-types/governance-newdoc-types.component";
import { GovernanceActivitiesEditComponent } from "./governance-activities/governance-activities-edit/governance-activities-edit.component";
import { GovernanceDocMappingComponent } from "./governance-doc-mapping/governance-doc-mapping.component";
const routes: Routes = [
  {
    path: '',
    component: GuestLayoutComponent,
    children: [
      { path: '', redirectTo: "/home", pathMatch: 'full' },
      { path: "login", component: LoginComponent },
      { path: "signin-oidc", component: SigninOidcComponent },
      {
        path: "home",
        component: LandingPageComponent,
        // canActivate: [MsalGuard],
        canActivate: [AuthGuard, EmployeeProfileUpdateGuard],
         resolve: {
           xsrf: AntiForgeryResolver
         },
        data: { breadcrumb: 'Home' }
      },
    ]
  },
  {
    path: '',
    component: AuthorisedLayoutComponent,
    children: [
      {
        path: "settings",
        component: AppSettingsComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Settings' }
      },
      {
        path: "configure-template",
        component: TemplateGeneratorComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Templates', claim: 'template-editor' }
      },
      {
        path: "configure-Immtemplate",
        component: ImmTemplateGeneratorComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'ImmTemplates', claim: 'imm-template-editor' }
      },

      {
        path: 'configure-activities',
        component: TaskAmendmentComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Configure activities', claim: 'amend-tasks' }
      },

      {
        path: "configure-immactivities",
        component: ImmTaskAmendmentComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Configure immigration activities', claim: 'imm-activity-editor' }
      },
      {
        path: "configure-immactivities/create",
        component: ImmTaskAmendmentEditComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Create Immigration activities', claim: 'imm-activity-editor' }
      },
      {
        path: "configure-immactivities/create/:visaCountry",
        component: ImmTaskAmendmentEditComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Create Immigration activities', claim: 'imm-activity-editor' }
      },
      {
        path: "configure-immactivities/create/:visaCountry/:visaType",
        component: ImmTaskAmendmentEditComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Create Immigration activities', claim: 'imm-activity-editor' }
      },
      {
        path: "configure-immactivities/edit/:id",
        component: ImmTaskAmendmentEditComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Edit Immigration activities', claim: 'imm-activity-editor' }
      },
      {
        path: "configure-governance-document-types",
        component: GovernanceDocTypesComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "Configure governance document types" }
      },
      {
        path: "configure-governance-newdocument-types",
        component: GovernanceNewdocTypesComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "Configure governance new document types" }
      },
      {
        path: "configure-governance-activities",
        component: GovernanceActivitiesComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "Configure governance activities" }
      },
      {
        path: "configure-governance-activities/create",
        component: GovernanceActivitiesEditComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "Create governance activity" }
      },
      {
        path: "configure-governance-activities/edit/:id",
        component: GovernanceActivitiesEditComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "Edit governance activity" }
      },
      {
        path: "configure-governance-doc-mapping",
        component: GovernanceDocMappingComponent,
        canActivate: [MsalGuard],
        data: { breadcrumb: "Configure governance doc mapping" }
      },
       {
        path: "configure-Govtemplate",
        component: GovTemplateGeneratorComponent,
         canActivate: [AuthGuard],
        data: { breadcrumb: 'Configure template' }
      },
      {
        path: "configure-exitactivities",
        component: ExitTaskAmendmentComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Configure exit activities', claim: 'exit-activity-editor' }
      },
      {
        path: "configure-exit-template-editor",
        component: ExitTemplateGeneratorComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Configure exit templates', claim: 'exit-template-editor' }
      },

      {
        path: 'configure-lookuptype/:module',
        component: LookupTypeAmendmentComponent,
        //canActivate: [AuthGuard],
        data: { breadcrumb: 'Configure lookuptype', claim: 'amend-lookuptype' }
      },

      { path: "logout", component: LogoutComponent },
      { path: "denied", component: UnauthorizedComponent },
      { path: "not-found", component: NotFoundComponent },

      {
        path: "privacy",
        component: PrivacyPolicyComponent,
        resolve: {
          xsrf: AntiForgeryResolver
        },
        data: { breadcrumb: 'Privacy', claim: 'IMM' }
      },

      {
        path: "recruitment",
        loadChildren: () =>
          import("./recruitment/recruitment.module").then(m => m.RecruitmentModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Recruitment', moduleid: 'm-rmt' }
      },
      {
        path: "pre-boarding",
        loadChildren: () =>
          import("./pre-boarding/pre-boarding.module").then(m => m.PreBoardingModule),
        canActivate: [AuthGuard],



        data: { breadcrumb: 'Pre-joining', claim: ['PTC', 'CanViewProfile-PTC', 'CanViewProfile-HM'], moduleid: 'm-ptc' }

      },
      {
        path: "immigration",
        loadChildren: () =>
          import("./immigration/immigration.module").then(m => m.ImmigrationModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Immigration', claim: 'IMM', moduleid: 'm-imm' }
      },
      {
        path: "user",
        loadChildren: () =>
          import("./user/user.module").then(m => m.UserModule),
        canActivate: [AuthGuard],
        resolve: {
          xsrf: AntiForgeryResolver
        },
        data: { breadcrumb: 'User' }
      },
      {
        path: "admin",
        loadChildren: () =>
          import("./admin/admin.module").then(m => m.AdminModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Admin', claim: 'ADM' }
      },
      {
        path: "exit",
        loadChildren: () =>
          import("./exit/exit.module").then(m => m.ExitModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Exit', claim: 'EXT', moduleid: 'm-ext' }
      },
      {
        path: "configure-immdocumentvisamapping",
        component: ImmDocumentVisamappingComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: "Configure Immigration Documents",
          claim: "imm-document-visamapping",
        },
      },
      {
        path: "subcontractor",
        loadChildren: () =>
          import("./contingent-worker/contingent-worker.module").then(m => m.ContingentWorkerModule),
        // canActivate: [AuthGuard],
        data: { breadcrumb: 'Sub Contractor', claim: 'CW', moduleid: 'm-cw' }
      },
      {
        path: "governance",
        loadChildren: () =>
          import("./governance/governance.module").then(m => m.GovernanceModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Governance', claim: 'IMM' }
      },
      { path: "**", redirectTo: "/home" }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

